module.exports = __webpack_public_path__ + "static/media/icon11.d2c7e55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon11.png
// module id = 385
// module chunks = 0 1